// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2UEbh","title":"AfterBackImages_title__BtGBL","images":"AfterBackImages_images__1gzRx"};